import * as bootstrap from "bootstrap"

export const showSkoteToast = (titleHTML, totalTime, delay = 5000) => {
  // Create toast container if not exists
  let container = document.getElementById("skote-toast-container")
  if (!container) {
    container = document.createElement("div")
    container.id = "skote-toast-container"
    container.className = "position-fixed top-0 end-0 p-3"
    container.style.zIndex = 9999
    document.body.appendChild(container)
  }

  // Get current time in HH:MM format
  const now = new Date()
  const hh = String(now.getHours()).padStart(2, "0")
  const mm = String(now.getMinutes()).padStart(2, "0")
  const currentTime = `${hh}:${mm}`

  // Convert totalTime "HH:MM" → "HH hours and MM minutes"
  const [hours, minutes] = totalTime.split(":")
  const formattedTime = `${parseInt(hours)} hours and ${parseInt(
    minutes
  )} minutes`

  // Create toast element
  const toastEl = document.createElement("div")
  toastEl.className =
    "toast text-bg-white shadow-md mb-2 rounded overflow-hidden position-relative"
  toastEl.setAttribute("role", "alert")
  toastEl.setAttribute("aria-live", "assertive")
  toastEl.setAttribute("aria-atomic", "true")

  toastEl.innerHTML = `
  <div class="toast-header align-items-center" style="background-color: #fff;">
    <i class="bi bi-alarm-fill me-2" style="color: #53176C;"></i>
    <strong class="me-auto" style="color: #7c3699;">Timer Stopped</strong>
    <small class="text-muted">${currentTime}</small>
    <button type="button" class="btn-close ms-2 mb-1" data-bs-dismiss="toast" aria-label="Close"></button>
  </div>
  <div class="toast-body" style="background-color: #fff;">
    ${titleHTML}<br/>
    <small>Working time: ${formattedTime}</small>
  </div>
  <div class="toast-progress position-absolute bottom-0 start-0" 
       style="height: 3px; width: 100%; background-color: #762C99;"></div>
`

  container.appendChild(toastEl)

  // Bootstrap toast instance
  const bsToast = new bootstrap.Toast(toastEl, { delay, autohide: true })
  bsToast.show()

  // Animate the progress bar
  const progress = toastEl.querySelector(".toast-progress")
  progress.animate([{ width: "100%" }, { width: "0%" }], {
    duration: delay,
    easing: "linear",
    fill: "forwards",
  })

  // Cleanup after hidden
  toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove())
}
